module.exports = __webpack_public_path__ + "img/public/SiteIcons/moreIcon.svg?d071415d";